VIV.behaviours.searchForm = (function () {

    const baseClass = 'searchForm';

    const attach = function (context) {
        context.querySelectorAll(`.${baseClass}`).forEach(element => {
            if (element.classList.contains('searchFormAttached')) {
                return;
            }
            element.classList.add('searchFormAttached');
            if (element.getAttribute('data-hide-submit') === 'true') {
                init(element);
            }
        });
    };

    const init = function (element) {
        const input = element.querySelector(`.${baseClass}__input`);
        const submitButton = element.querySelector(`.${baseClass}__button`);

        if (input && submitButton) {
            input.addEventListener('keyup', () => onInputChange(input, submitButton));
            input.addEventListener('change', () => onInputChange(input, submitButton));
            onInputChange(input, submitButton);
        }
    };

    const onInputChange = function (input, button) {
        if (input.value === '') {
            button.setAttribute('disabled', 'disabled');
        } else {
            button.removeAttribute('disabled');
        }
    }

    return {
        attach: attach
    }
})();
